import React from 'react';
import PropTypes from 'prop-types';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Inline } from 'web-ui-components/lib/layout/grids';

function GridThatsAll({
  loadTransactionsFlag = false,
  onFooterClick,
  thatsAllMessage = 'That’s all we can find. Try changing your date range?',
  gridFooterCss = 'accountTransactionGridBottomText',
}) {
  return loadTransactionsFlag ? (
    <Inline.Centered
      nodes={[
        <ActionButton.Primary
          labelText="Show more"
          onClick={(e) => {
            e.preventDefault();
            onFooterClick();
          }}
        />,
      ]}
    />
  ) : (
    <div className={gridFooterCss}>{thatsAllMessage}</div>
  );
}

GridThatsAll.propTypes = {
  loadTransactionsFlag: PropTypes.bool,
  onFooterClick: PropTypes.func.isRequired,
  thatsAllMessage: PropTypes.string,
  gridFooterCss: PropTypes.string,
};

export { GridThatsAll };
